import Sidebar from "../../components/Sidebar";
import React, {useEffect, useState} from "react";
import AdminPageHeader from "../../components/Header/AdminPageHeader";
import {accountInfo} from "../../constants/constants";
import {Environment} from "../../utils/_dummyData";
import {
  ALL_CUSTOMER_MANAGEMENT_PAGE,
  ALL_STORE_LIST_MANAGEMENT_PAGE,
} from "../../constants/page_constants";
import AdminNoticeModal from "../../components/Modal/AdminNoticeModal";
import neverLandUtils from "../../utils/NeverLandUtils";
import {Link} from "react-router-dom";
import BankerHeader from "../../components/Header/BankerHeader";

const BankerGrantPermissionsPage = () => {


  return (
      <div>

        <Sidebar/>

        <main className="lg:pl-64 min-h-screen">
          <BankerHeader/>

              <div className="min-h-screen pt-32 pl-14 flex flex-col">
                <div className="flex flex-col justify-start">

                  <button
                      className="w-48 gap-x-3 rounded-md p-2 h-10 text-sm leading-6 font-semibold bg-emerald-600 text-white whitespace-nowrap text-center my-5">
                    뱅커 권한부여
                  </button>

                  <button
                      className="w-48 gap-x-3 rounded-md p-2 h-10 text-sm leading-6 font-semibold bg-violet-900 text-white whitespace-nowrap text-center my-5">
                    추천인 권한부여
                  </button>
                </div>
              </div>

        </main>
      </div>
  )
}
export default BankerGrantPermissionsPage;